import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {loc} from "core/common/config/locales";


const gridLocation = 'documentTypeList';

@observer
export default class DocumentTypeList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Document Types`;
  static icon = 'file-text';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("DocumentTypeList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
    });

  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="documentTypeDetail" params={{id: 'new'}} label="New Document Type" permission={PERMISSION.New} securable={PAGE.documentTypeDetail}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/document/documentTypeList.tsx